import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_ASSURANCE_TICKET } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDassuranceTicketState extends EntityState<IID_ASSURANCE_TICKET, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_ASSURANCE_TICKET , realtimeEntity: 'IID_Assurance_ticket'})
@InterfaceDataStore(InterfaceName.ASSURANCE_TICKET)
export class IIDassuranceTicketStore extends EntityStore<IIDassuranceTicketState> {
  constructor() {
    super([]);
  }
}
